<template>
  <div>
    <div class="deemLogo"></div>
    <div class="container">
      <div class="layout1">
        <p class="titleText">
          Earn a very attractive return with Deem High Yield Deposits.
        </p>
        <p class="descText">
          <br />Make your excess business cash work for you. Opt for our unique
          <a :href="websiteUrl">High Yield Deposits</a>. With rates as high as 7%* p.a., maximize
          the returns on your business savings. Choose a tenor that works with your business’
          realities. Just send us your details and we will contact you!
        </p>
        <p class="descText"><br />*Terms and Conditions apply.</p>
      </div>
      <div class="layout2">
        <MainForm
          :name="FORM_NAMES.corporate"
          :show-step="isOnStep"
          :logic-callbacks="getLogicCallback"
          :ui-form="uiForm"
          :end-page-data="endPageData"
          :ui-modal-and-end-page="uiModalAndEndPage"
          ui-title="Main form title"
        >
          <StepModel
            :ui="uiBaseStep"
            :name="STEP_NAMES.contact"
            ui-title="Contact Information"
            ui-subtitle=""
            ui-error-message="Please review the fields marked in red"
            ui-button-text="Submit"
          >
            <FieldsetFullName />
            <FieldsetModel :ui="uiBaseFieldset" name="companyName" ui-title="Company Name">
              <UiWrapper :name="FIELD_NAMES.companyName" label="Type the name of your company">
                <InputText />
              </UiWrapper>
            </FieldsetModel>
            <FieldsetEmail subtitle="" />

            <FieldsetMobilePhone subtitle="" />
            <!-- <FieldsetModel :ui="uiBaseFieldset" name="productInterested" ui-title="Product Interested">
          <UiWrapper :name="FIELD_NAMES.productInterested">
            <Dropdown
              placeholder="Select Product"
              :options="[
                { value: 'Corporate Deposit', label: 'Corporate Deposit' },
                { value: 'High Yield', label: 'High Yield' },
                {
                  value: 'Financial Guarantees',
                  label: 'Financial Guarantees'
                },
                { value: 'Payroll Solutions', label: 'Payroll Solutions' }
              ]"
            />
          </UiWrapper>
        </FieldsetModel> -->
          </StepModel>

          <!-- <StepOtp :change-phone-action="goToStep(STEP_NAMES.contact)" /> -->
        </MainForm>
      </div>
    </div>
  </div>
</template>

<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import FIELD_NAMES from "@/forms/constants/field-names";
import * as conditions from "@/forms/conditions";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldsetModel from "@/lib/components/models/fieldset";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";

import StepOtp from "@/forms/components/shared/steps/otp";

import FieldsetEmail from "@/forms/components/shared/fieldsets/email";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import { Dropdown, InputText } from "@dunia/ui";
export default {
  name: "Corporate",

  components: {
    MainForm,
    StepModel,
    StepOtp,
    FieldsetEmail,
    FieldsetMobilePhone,
    FieldsetFullName,
    FIELD_NAMES,
    FieldsetModel,
    UiWrapper,
    Dropdown,
    InputText
  },

  mixins: [FormComponentMixin],
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }

    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-TS4C5R4");
  },
  methods: {
    finishCallback() {
      var titleMessage = `Thank you for your interest.`;
      var subtitleMessage = `Our team will get back to you shortly.`;
      this.showEndPage({
        title: titleMessage,
        subtitle: subtitleMessage
        //actionNameEndForm: "Thanks"
      });

      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-TS4C5R4");
    }
  },

  data() {
    return {
      websiteUrl: "https://www.deem.io/corporate/high-yield-deposit"
    };
  }
};
</script>

<style scoped>
.deemLogo {
  width: 85px;
  height: 35px;
  background-size: 85px 35px;
  top: 30px;
  left: 90px;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-image: url(/img/assets/icons/deemlogo-email.jpg);
  position: absolute;
  /* -webkit-animation: .5s ease 0s normal forwards 1 fadein;
    animation: s ease 0s normal forwards 1 fadein; */
}
.container {
  display: flex;
  align-items: center;
  height: 120vh;
}

.layout1 {
  flex: 1;
  padding-right: 40px;
}
.layout2 {
  flex: 1;

  /* Additional styling for each layout */
}
.titleText {
  color: #000;
  font-size: 32px;
  line-height: 44px;
  letter-spacing: -1px;
  font-family: "Moderat", serif;
  font-weight: 600;
  font-feature-settings: "ss02";
  -webkit-font-smoothing: antialiased;
}
.descText {
  color: #000;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -1px;
  font-weight: 370;
  font-family: "Moderat", serif;
}
</style>
